import React from 'react';

import { BlockMenu } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import { UseDraggableItemReturnType } from '@/modules/corporate/components/DraggableList/hooks/useDraggableItem/types';
import OptionsListItem from '@/modules/corporate/modules/questions/fields/components/Editor/OptionsListItem';
import { EditorOptionsListItemProps } from '@/modules/corporate/modules/questions/fields/components/Editor/OptionsListItem/types';

type SingleSelectEditorOptionsListItem = EditorOptionsListItemProps & {
  getDragHandleProps: UseDraggableItemReturnType['getDragHandleProps'];
  showEvaluation?: boolean;
  showWeight?: boolean;
  isLocalizedContent?: boolean;
};

const CLASSES = { root: 'px-12', optionItem: 'ms-16' };

function EditorOptionsListItem(props: SingleSelectEditorOptionsListItem) {
  const { disableReordering, getDragHandleProps } = props;

  const isDeletable = !Boolean(props.option.optionId?.length);

  return (
    <Stack className="group group/option mb-10" gapX={8}>
      <BlockMenu
        className={cn('my-14 h-16 w-16 flex-shrink-0 opacity-0', {
          'group-hover:opacity-100': !disableReordering,
        })}
        fillColorToken="icon-placeholder"
        {...getDragHandleProps()}
      />
      <OptionsListItem {...props} classes={CLASSES} isDeletable={isDeletable} />
    </Stack>
  );
}

export default EditorOptionsListItem;
